import { Component, HostBinding, Input } from '@angular/core';
import { SvgIconComponent } from '../svg-icon/svg-icon.component';
import { NgIf } from '@angular/common';

type ButtonType = 'primary' | 'secondary' | 'danger' | 'transparent';
@Component({
  selector: 'ui-button',
  standalone: true,
  imports: [NgIf, SvgIconComponent],
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss'],
})
export class ButtonComponent {
  @Input() label!: string | undefined;
  @Input() abbreviation!: string | undefined;
  @Input() icon?: string;
  @Input() iconPosition: 'start' | 'end' = 'start';
  @Input() iconSize: 'small' | 'medium' | 'large' = 'medium';
  @Input() type: ButtonType = 'primary';
  @Input() disabled = false;
  @Input() fullWidth = false;
  @Input() isLoading = false;

  // Conditionally apply the class on the host element
  @HostBinding('class.full-width') get isFullWidth() {
    return this.fullWidth;
  }
}
